import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const MainTitle = styled.h2`

`;

export const BackText = styled.h4`
    text-align: start;
    cursor: pointer;
`;